import { render, staticRenderFns } from "./EditproductPage.vue?vue&type=template&id=612cc1a0"
import script from "./EditproductPage.vue?vue&type=script&lang=js"
export * from "./EditproductPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports